export default "/images/76e7d3abc035faed9d41732bd8d7839b.avif";